import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a213b4be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup edit" }
const _hoisted_2 = { class: "popup-header spacer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_4 = { class: "popup-content small-padding" }
const _hoisted_5 = { class: "members" }
const _hoisted_6 = {
  key: 0,
  class: "member"
}
const _hoisted_7 = { class: "name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_9 = { class: "popup-footer" }

import PopupCancelButton from "@/components/popup/PopupCancelButton.vue";
import UsersSelectBox from "@/components/select/UsersSelectBox.vue";
import ProfileImage from "@/components/images/ProfileImage.vue";
import { User } from "@/store/users/state";
import { IconType } from "@/types/icons";
import { AllMutationTypes } from "@/store/mutationTypes";
import { useStore } from "vuex";
import Icon from "@/components/icons/Icon/Icon.vue";

interface Props {
  members: User[];
  isAddMembersShown: boolean;
  itemIcon: IconType;
  title: string;
  action?: () => void;
  actionTitle?: string;
  confirmTitle: string;
}

interface Emits {
  (e: "add-member", member: User): void;
  (e: "item-action", member: User): void;
  (e: "confirm"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopSelectChatWrapper',
  props: {
    members: {},
    isAddMembersShown: { type: Boolean },
    itemIcon: {},
    title: {},
    action: { type: Function },
    actionTitle: {},
    confirmTitle: {}
  },
  emits: ["add-member", "item-action", "confirm"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const { commit } = useStore();

const addMember = (member: User) => {
  emit("add-member", member);
};
const handleItemAction = (member: User) => {
  emit("item-action", member);
};

const handleConfirm = () => {
  emit("confirm");
  commit(AllMutationTypes.HIDE_POPUP);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
      (_ctx.actionTitle && !!_ctx.action)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "highlight hover",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.action && _ctx.action(...args)))
          }, _toDisplayString(_ctx.actionTitle), 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isAddMembersShown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(Icon, {
                icon: _unref(IconType).DEFAULT_SINGLE_GRAY,
                class: "picture"
              }, null, 8, ["icon"]),
              _createVNode(UsersSelectBox, { onSetSelectedUsers: addMember })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
          return (_openBlock(), _createElementBlock("div", {
            key: member.id,
            class: "member"
          }, [
            _createVNode(ProfileImage, {
              id: member.id,
              image: member.picture,
              size: 54
            }, null, 8, ["id", "image"]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(member.name), 1),
            _createVNode(Icon, {
              icon: _ctx.itemIcon,
              class: "icon",
              onClick: ($event: any) => (handleItemAction(member))
            }, null, 8, ["icon", "onClick"])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(PopupCancelButton),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: handleConfirm
      }, _toDisplayString(_ctx.confirmTitle), 1)
    ])
  ]))
}
}

})